
  export default {
    name: 'BaseRating',
    props: {
      grade: {
        type: Number,
        default: undefined,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      enterGrade: {
        type: Boolean,
        default: false,
      },
      size: {
        type: Number,
        default: 16,
      },
      color: {
        type: String,
        default: 'primaryYellow',
      },
    },
    data() {
      return {
        rating: 0,
      };
    },
  };
